// extracted by mini-css-extract-plugin
export default {"gridimage":"movieGrid_gridimage__3BCEv","moviegrid":"movieGrid_moviegrid__NTLIl"};